import Cookies from "js-cookie";
import configs from "./configs";

export function getCookieToken() {
  return localStorage.getItem("auth0Token") || Cookies.get(configs["JWT_COOKIE"]);
}

export async function apiRequest(method, url, body) {
  const cookie = getCookieToken();

  const response = await fetch(url, {
    method: method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${cookie}`,
      Accept: "application/json"
    },
    body: JSON.stringify(body)
  }).catch(e => {
    console.error(e);
    return false;
  });

  if (!response.ok) {
    console.error(response);
    return false;
  }

  const data = await response.json();

  return data;
}

export async function getEvent(slug) {
  const url = configs["CUSTOM_API_URL"] + "/events/" + slug;

  const response = await apiRequest("GET", url);

  return response?.data;
}

export function getEventsCookie() {
  return JSON.parse(Cookies.get("events") || "[]");
}

export async function userIsInTheEvent(user, slug) {
  const eventsCookie = getEventsCookie();

  if (eventsCookie.includes(slug)) {
    return true;
  }

  const url = configs["CUSTOM_API_URL"] + "/events/" + slug + "/users/" + user.id + "/is-in";

  const response = await apiRequest("POST", url);

  return response?.data?.is_in_event;
}

export function getStartTime(data) {
  return new Date(data.start_time_next ?? data.start_time).getTime();
}

export function getEndTime(data) {
  if (!data) return 0;

  return new Date(data.end_time_next ?? data.end_time).getTime();
}

export function getRoomPresentation(event, roomId, roomName) {
  return (
    event?.presentations?.meeting?.metaverse_room?.find(room => room.id === roomId) ||
    event?.presentations?.find(presentation => presentation.name === roomName)
  );
}

export function eventHasStarted(startTime) {
  return startTime < Date.now();
}

export function eventHasConcluded(endTime) {
  return endTime < Date.now();
}

// startTime and endTime are Date objects
export function getRelativeStartTime(startTime, endTime) {
  const now = new Date();

  if (now < startTime) {
    // Return it in days, hours, minutes or seconds based on the difference between now and the start time
    const diff = startTime - now;

    if (diff > 86400000) {
      return `Starting in ${Math.floor(diff / 86400000)} days`;
    }

    if (diff > 3600000) {
      return `Starting in ${Math.floor(diff / 3600000)} hours`;
    }

    if (diff > 60000) {
      return `Starting in ${Math.floor(diff / 60000)} minutes`;
    }

    return `Starting in ${Math.floor(diff / 1000)} seconds`;
  }

  if (now > startTime && now < endTime) {
    return "LIVE";
  }

  if (now > endTime) {
    return "Concluded";
  }
}

export function getPresentersNames(presentation) {
  return presentation?.presenters?.map(presenter => presenter.name).join(", ");
}
